import type {Copilot} from '@github-ui/agent-sessions/components/copilot-assignment/copilot-assignment-types'
import {CopilotAssignmentModal} from '@github-ui/agent-sessions/components/copilot-assignment/CopilotAssignmentModal'
import {CodingAssistantButton} from '@github-ui/coding-assistant-button'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useCallback, useRef, useState} from 'react'

type StartWorkButtonProps = {
  url: string
  planBody: string
  repository: {
    name: string
    owner: {login: string}
  }
  issueNumber: number
  onAssignmentComplete?: (copilot?: Copilot) => Promise<void> | void
}

export function StartWorkButton({url, planBody, repository, issueNumber, onAssignmentComplete}: StartWorkButtonProps) {
  const [modalOpen, setModalOpen] = useState(false)
  const buttonRef = useRef<HTMLElement | null>(null)
  const agentAssignmentEnabled = isFeatureEnabled('issue_cca_modal_open')

  const handleOpenModal = useCallback(() => {
    setModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setModalOpen(false)
  }, [])

  return (
    <>
      <CodingAssistantButton
        anchorRef={buttonRef}
        url={url}
        buttonLabel="Start work"
        promptBuilder={(issueUrl: string) =>
          `I've created a plan for ${issueUrl}, please implement this plan:\n\n${planBody.trim()}`
        }
        size="small"
        showSettingsLink={isFeatureEnabled('coding_tool_settings')}
        onAssignToAgent={agentAssignmentEnabled ? handleOpenModal : undefined}
      />
      {agentAssignmentEnabled && modalOpen && (
        <CopilotAssignmentModal
          isOpen={modalOpen}
          onClose={handleCloseModal}
          repository={repository}
          issueNumbers={[issueNumber]}
          onAssignmentComplete={onAssignmentComplete}
          returnFocusRef={buttonRef}
          initialFormCustomizations={{
            content: `I've created a plan for ${url}, please implement this plan:\n\n${planBody.trim()}`,
            selectedRepo: null,
            selectedBranch: '',
          }}
        />
      )}
    </>
  )
}
